module.exports = __webpack_public_path__ + "img/Vector (2).c2ca7440.svg";